
    import '/opt/buildhome/repo/packages/x/CHANGELOG.zh-CN.md?watch=parent';
    export const demoIndex = {
  ids: [],
  getter: () => import(/* webpackChunkName: "meta__CHANGELOG.zh-CN.md__zh-CN" */'/opt/buildhome/repo/packages/x/CHANGELOG.zh-CN.md?type=demo')
};